import React from 'react';
import { FaGithub } from "react-icons/fa";
import { CiLinkedin } from "react-icons/ci";
import { FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

const SocailMedia = () => {
  return (
    <div className='app__social'>
      <div>
        <a href='https://github.com/Hamzaisadev' target='_blank' rel='noopener noreferrer'>
          <FaGithub />
        </a>
      </div>
      <div>
        <a href='https://www.linkedin.com/in/hamzaisadev/' target='_blank' rel='noopener noreferrer'>
          <CiLinkedin />
        </a>
      </div>
      <div>
        <a href='https://wa.link/5n9agp' target='_blank' rel='noopener noreferrer'>
          <FaWhatsapp />
        </a>
      </div>
      <div>
        <a href='https://www.instagram.com/_gottalovehamza/' target='_blank' rel='noopener noreferrer'>
          <FaInstagram  />
        </a>
      </div>
    </div>
  )
}

export default SocailMedia;